import {useState} from 'react';

import {Stack} from 'shells/layout/stack/stack';

import {appHistory} from '../../../../../history';

import {useAddSharedEmailAddress} from '../../graphql/hooks/use-add-shared-email-address';

import {EmailSettingsSetupFooter} from './email-settings-setup-footer';
import {EmailSettingsSetupStepContent} from './email-settings-setup-step-content';
import {EmailSetupStep} from './types';

export function EmailSettingsSetup() {
    const [currentStep, setCurrentStep] = useState<EmailSetupStep>(EmailSetupStep.ADD_EMAIL);
    const [emailAddress, setEmailAddress] = useState<string>('');
    const [displayName, setDisplayName] = useState<string>(NutClientConfig.instanceName || '');

    const {addSharedEmailAddress, isLoading, error} = useAddSharedEmailAddress();

    const handleNext = () => {
        if (emailAddress.trim()) {
            setCurrentStep(EmailSetupStep.NAME_INBOX);
        }
    };

    const handleSave = async () => {
        const trimmedDisplay = displayName.trim();
        if (!trimmedDisplay) {
            return;
        }

        const {data} = await addSharedEmailAddress({
            emailAddress: emailAddress.trim(),
            displayName: trimmedDisplay,
        });

        const fromAddressId = data?.sharedEmailAddressAdd.fromAddress.id;
        if (fromAddressId) {
            appHistory.push(`/inbox/settings/email/${fromAddressId}`);
        }
    };

    return (
        <Stack spacing={16} isFullWidth={true} isFullHeight={true}>
            <div className='flex flex-dir-col justify-center full-width pad-16 background-offwhite align-center gap-24 flex-grow'>
                <EmailSettingsSetupStepContent
                    currentStep={currentStep}
                    emailAddress={emailAddress}
                    setEmailAddress={setEmailAddress}
                    displayName={displayName}
                    setDisplayName={setDisplayName}
                    onNext={handleNext}
                    onSave={handleSave}
                    error={error}
                />
            </div>
            <EmailSettingsSetupFooter
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                emailAddress={emailAddress}
                displayName={displayName}
                isLoading={isLoading}
                onNext={handleNext}
                onSave={handleSave}
            />
        </Stack>
    );
}
